import { TAvailableConfigValues } from '@customTypes/common';

export interface IOriginalTargetBufferDecreaserConfig {
  periodOfEventsToCancelDecrease: number;
  allowTargetBufferDecrease: boolean;
  targetBufferDecreaseTimeout: number;
  maxTargetBufferMultiplier: number;
}

export interface IOriginalTargetBufferAdditionalInfo {
  isDecreasingDisabled: boolean;
  currentMultiplier: number;
}

export const defaultOriginalTargetBufferDecreaserConfig: IOriginalTargetBufferDecreaserConfig = {
  periodOfEventsToCancelDecrease: 10000,
  allowTargetBufferDecrease: false,
  targetBufferDecreaseTimeout: 10000,
  maxTargetBufferMultiplier: 4,
};

export const availableOriginalTargetBufferDecreaserConfigValues: TAvailableConfigValues<IOriginalTargetBufferDecreaserConfig> = {};
